import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

const IdentifierPage = lazy(() => import("../Pages/identifier"));
const DiagnosisPage = lazy(() => import("../Pages/diagnosis"));
const Home = lazy(() => import("../Pages/home"));
const Contact = lazy(() => import("../Pages/contact"));

const MyRoutes = () => {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Routes>
                <Route path="/" element={<Navigate to="/home" />} />
                <Route path="/home" element={<Home />} />
                <Route path="/plant-identife" element={<IdentifierPage />} />
                <Route path="/plant-diagnosis" element={<DiagnosisPage />} />
                <Route path="/contact" element={<Contact />} />
            </Routes>
        </Suspense>
    );
}

export default MyRoutes;
